import { unit } from 'modules/v2/foundation/spacing';
export const getSizeFromProps = (props) => unit(props.$size);
export const getPrimaryColorFromProps = (props) => props.$primaryColor;
export const getSrcFromProps = (props) => props.$src;
export const getAlignmentFromProps = (props) => props.$alignment;
